export default __webpack_public_path__ + "static/media/misc-closetC-1920w.6cd091f7.png";